const getGradeband = (gradelevel: number) => {
  let gradeband = "3-5";
  if (gradelevel <= 2) gradeband = "k-2";
  if (gradelevel > 5 && gradelevel <= 8) gradeband = "6-8";
  if (gradelevel > 8) gradeband = "9-12";

  return gradeband;
};

export default getGradeband;
